/**
 * Exports CSV from given data and field mapping.
 *
 * @param {Object} config
 * @param {Array<Object>} config.data - Array of row objects.
 * @param {Object} config.fields - Key-value pairs where key = object field, value = CSV column name.
 * @param {string} config.filename - Used for the download file name.
 * @param {string} [config.header] - Optional: A title/header to put at the top of the CSV file.
 */
export const exportCsvV2 = ({ data, fields, filename, header }) => {
  const fieldKeys = Object.keys(fields);
  const topHeader = header ?? filename;
  const headers = fieldKeys.map(key => `"${fields[key] || ''}"`).join(',');

  // auto quote safe mode
  // const rows = data
  //   .map(row =>
  //     fieldKeys
  //       .map(key => {
  //         const val = row[key] ?? '';
  //         const safeValue = `${val}`.replace(/"/g, '""'); // Escape quotes
  //         return `"${safeValue}"`;
  //       })
  //       .join(',')
  //   )
  //   .join('\n');

  // remove quotes
  const rows = data
    .map(row =>
      fieldKeys
        .map(key => {
          const val = row[key] ?? '';
          return `${val}`; // no escaping, no quotes
        })
        .join(',')
    )
    .join('\n');

  const csvString = `${topHeader}\n${headers}\n${rows}`;

  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
